import { render, staticRenderFns } from "./forgotten-password-request-page.vue?vue&type=template&id=720b5beb"
import script from "./forgotten-password-request-page.vue?vue&type=script&lang=js"
export * from "./forgotten-password-request-page.vue?vue&type=script&lang=js"
import style0 from "./forgotten-password-request-page.vue?vue&type=style&index=0&id=720b5beb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./forgotten-password-request-page.vue?vue&type=custom&index=0&blockType=vuejs3-todo"
if (typeof block0 === 'function') block0(component)

export default component.exports